export const DEFAULT_ERROR = "DEFAULT_ERROR";
export const LOGIN_DEFAULT_ERROR = "LOGIN_DEFAULT_ERROR";